import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'

import { ButtonToolbar } from 'react-bootstrap'

import ConvertButton from '../../components/ConvertButton'
import ExportButton from '../../components/ExportButton'
import AnalyzeButton from '../../components/AnalyzeButton'

@observer
class ButtonBar extends Component {
  render() {
    return (
      <ButtonToolbar>
        <ConvertButton
          dataClasses={this.props.dataClasses}
          dataClassLabels={this.props.dataClassLabels}
          ids={this.props.ids}
        />
        <ExportButton
          dataClasses={this.props.dataClasses}
          ids={this.props.ids}
        />
        <AnalyzeButton
          dataClasses={this.props.dataClasses}
          ids={this.props.ids}
        />
      </ButtonToolbar>
    )
  }
}

ButtonBar.propTypes = {
  dataClasses: PropTypes.array,
  dataClassLabels: PropTypes.object.isRequired,
  ids: PropTypes.array,
}

export default ButtonBar
